import { ScriptLoadingStates, useScript } from "@/utils/hooks/useScript.hook";

const KLARNA_PLACEMENT_KEY = "credit-promotion-auto-size";
const KLARNA_PLACEMENT_ID = "klarna-placement";

type Props = {
    klarnaClientId: string;
    klarnaClientSrc: string;
    environmentAttribute: string;
    locale: string;
    amount: string;
};

export const Placement = ({
    amount,
    klarnaClientId,
    klarnaClientSrc,
    environmentAttribute,
    locale
}: Props) => {
    const { status } = useScript({
        src: klarnaClientSrc,
        id: "klarna-osm",
        attributes: {
            "data-environment": environmentAttribute,
            "data-client-id": klarnaClientId
        }
    });

    if (status !== ScriptLoadingStates.Ready) {
        return null;
    }

    return (
        <klarna-placement
            id={KLARNA_PLACEMENT_ID}
            data-key={KLARNA_PLACEMENT_KEY}
            data-locale={locale}
            data-purchase-amount={amount}
        ></klarna-placement>
    );
};
